import React from 'react';

import { SvgIcon } from '@mui/material';
import classNames from 'classnames';

import { useStyles } from '../Icon.styles';
import { LegacyIconProps } from '../Icon.types';

export const Thinking = ({
  size = 'default',
  color = 'secondary',
}: LegacyIconProps) => {
  const { classes } = useStyles();

  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(
        classes[`icon_size_${size}` as const],
        classes[`icon_color_${color}` as const],
      )}
    >
      <path
        d="M10.0146 16.9355C13.8979 16.9355 17.0459 13.7875 17.0459 9.9043C17.0459 6.02104 13.8979 2.87305 10.0146 2.87305C6.1314 2.87305 2.9834 6.02104 2.9834 9.9043C2.9834 13.7875 6.1314 16.9355 10.0146 16.9355Z"
        fill="url(#paint0_radial_4706_230499)"
      />
      <path
        d="M10.0146 16.9355C13.8979 16.9355 17.0459 13.7875 17.0459 9.9043C17.0459 6.02104 13.8979 2.87305 10.0146 2.87305C6.1314 2.87305 2.9834 6.02104 2.9834 9.9043C2.9834 13.7875 6.1314 16.9355 10.0146 16.9355Z"
        fill="url(#paint1_radial_4706_230499)"
      />
      <path
        d="M10.0146 16.9355C13.8979 16.9355 17.0459 13.7875 17.0459 9.9043C17.0459 6.02104 13.8979 2.87305 10.0146 2.87305C6.1314 2.87305 2.9834 6.02104 2.9834 9.9043C2.9834 13.7875 6.1314 16.9355 10.0146 16.9355Z"
        fill="url(#paint2_radial_4706_230499)"
      />
      <path
        d="M10.0176 16.916C13.9008 16.916 17.0488 13.768 17.0488 9.88477C17.0488 6.00151 13.9008 2.85352 10.0176 2.85352C6.13433 2.85352 2.98633 6.00151 2.98633 9.88477C2.98633 13.768 6.13433 16.916 10.0176 16.916Z"
        fill="url(#paint3_radial_4706_230499)"
        fillOpacity="0.8"
      />
      <path
        d="M10.0176 2.85352C6.13433 2.85352 2.98633 6.00151 2.98633 9.88476C2.98633 13.768 6.13433 16.916 10.0176 16.916C13.9008 16.916 17.0488 13.768 17.0488 9.88477C17.0488 6.00151 13.9008 2.85352 10.0176 2.85352Z"
        fill="url(#paint4_radial_4706_230499)"
        fillOpacity="0.8"
      />
      <g opacity="0.4" filter="url(#filter0_f_4706_230499)">
        <path
          d="M13.6278 5.16661C13.6278 6.17605 12.0244 6.99436 10.0463 6.99436C8.06834 6.99436 6.46484 6.17605 6.46484 5.16661C6.46484 4.15718 8.06834 3.33887 10.0463 3.33887C12.0244 3.33887 13.6278 4.15718 13.6278 5.16661Z"
          fill="url(#paint5_radial_4706_230499)"
        />
      </g>
      <path
        opacity="0.7"
        d="M6.42166 15.552C5.08485 15.1923 4.2177 14.0926 4.48484 13.0956C4.75198 12.0986 6.05224 11.5819 7.38906 11.9416C8.72587 12.3012 9.59301 13.401 9.32587 14.398C9.05873 15.3949 7.75847 15.9116 6.42166 15.552Z"
        fill="url(#paint6_radial_4706_230499)"
      />
      <path
        opacity="0.7"
        d="M9.65433 14.2163C8.34551 14.6673 7.16431 14.6852 7.01606 14.2563C6.8678 13.8275 7.80864 13.1142 9.11746 12.6632C10.4263 12.2123 11.6075 12.1943 11.7557 12.6232C11.904 13.0521 10.9632 13.7653 9.65433 14.2163Z"
        fill="url(#paint7_radial_4706_230499)"
      />
      <path
        opacity="0.7"
        d="M9.21101 13.4077C7.65072 13.7055 6.31654 13.5855 6.23105 13.1399C6.14555 12.6943 7.34111 12.0917 8.9014 11.794C10.4617 11.4962 11.7959 11.6161 11.8814 12.0618C11.9669 12.5074 10.7713 13.11 9.21101 13.4077Z"
        fill="url(#paint8_radial_4706_230499)"
      />
      <path
        d="M12.8641 5.54814C12.2763 5.24232 11.7828 5.21242 11.4866 5.29771C11.3714 5.33114 11.2682 5.46331 11.2521 5.57604C11.2436 5.63546 11.2621 5.7139 11.292 5.78056C11.3376 5.88211 11.4417 5.91949 11.5457 5.94159C12.4847 6.0758 12.8218 6.21304 13.4729 6.71874C13.6303 6.84101 13.8346 7.12699 13.9417 7.04738C14.0488 6.96777 14.0646 6.73499 13.7898 6.33395C13.5579 5.99544 13.2105 5.72841 12.8634 5.54777L12.8641 5.54814Z"
        fill="url(#paint9_radial_4706_230499)"
      />
      <path
        d="M12.8641 5.54814C12.2763 5.24232 11.7828 5.21242 11.4866 5.29771C11.3714 5.33114 11.2682 5.46331 11.2521 5.57604C11.2436 5.63546 11.2621 5.7139 11.292 5.78056C11.3376 5.88211 11.4417 5.91949 11.5457 5.94159C12.4847 6.0758 12.8218 6.21304 13.4729 6.71874C13.6303 6.84101 13.8346 7.12699 13.9417 7.04738C14.0488 6.96777 14.0646 6.73499 13.7898 6.33395C13.5579 5.99544 13.2105 5.72841 12.8634 5.54777L12.8641 5.54814Z"
        fill="#814D1E"
      />
      <path
        d="M12.8641 5.54814C12.2763 5.24232 11.7828 5.21242 11.4866 5.29771C11.3714 5.33114 11.2682 5.46331 11.2521 5.57604C11.2436 5.63546 11.2621 5.7139 11.292 5.78056C11.3376 5.88211 11.4417 5.91949 11.5457 5.94159C12.4847 6.0758 12.8218 6.21304 13.4729 6.71874C13.6303 6.84101 13.8346 7.12699 13.9417 7.04738C14.0488 6.96777 14.0646 6.73499 13.7898 6.33395C13.5579 5.99544 13.2105 5.72841 12.8634 5.54777L12.8641 5.54814Z"
        fill="#5C3147"
      />
      <path
        d="M7.70122 5.00391C8.42526 5.00391 8.89396 5.47801 9.08955 5.70462C9.19087 5.82202 9.25525 5.94028 9.24244 6.12276C9.23654 6.20673 9.17147 6.30415 9.08826 6.32339C8.8706 6.37371 8.73527 6.21252 8.56454 6.0568C7.87884 5.43142 7.08504 5.52481 6.33866 6.12351C6.21562 6.22221 6.0033 6.33397 5.97151 6.2222C5.92445 6.0568 6.18222 5.76388 6.27497 5.67928C6.44704 5.52231 6.94031 5.00391 7.70122 5.00391Z"
        fill="url(#paint10_radial_4706_230499)"
      />
      <path
        d="M7.70122 5.00391C8.42526 5.00391 8.89396 5.47801 9.08955 5.70462C9.19087 5.82202 9.25525 5.94028 9.24244 6.12276C9.23654 6.20673 9.17147 6.30415 9.08826 6.32339C8.8706 6.37371 8.73527 6.21252 8.56454 6.0568C7.87884 5.43142 7.08504 5.52481 6.33866 6.12351C6.21562 6.22221 6.0033 6.33397 5.97151 6.2222C5.92445 6.0568 6.18222 5.76388 6.27497 5.67928C6.44704 5.52231 6.94031 5.00391 7.70122 5.00391Z"
        fill="#814D1E"
      />
      <path
        d="M7.70122 5.00391C8.42526 5.00391 8.89396 5.47801 9.08955 5.70462C9.19087 5.82202 9.25525 5.94028 9.24244 6.12276C9.23654 6.20673 9.17147 6.30415 9.08826 6.32339C8.8706 6.37371 8.73527 6.21252 8.56454 6.0568C7.87884 5.43142 7.08504 5.52481 6.33866 6.12351C6.21562 6.22221 6.0033 6.33397 5.97151 6.2222C5.92445 6.0568 6.18222 5.76388 6.27497 5.67928C6.44704 5.52231 6.94031 5.00391 7.70122 5.00391Z"
        fill="#5C3147"
      />
      <path
        d="M9.08945 10.586C11.3828 10.9242 11.8348 10.017 12.109 10.3341C12.3453 10.6073 10.9591 11.6542 9.08945 11.415C7.62781 11.228 6.88949 10.0721 7.09678 9.90767C7.50077 9.58715 7.42112 10.34 9.08945 10.586Z"
        fill="#421D30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0274 10.036C12.1328 10.0512 12.219 10.1039 12.2857 10.181C12.3885 10.2999 12.3803 10.4435 12.3445 10.5462C12.3102 10.6446 12.2435 10.7351 12.1693 10.8134C12.018 10.9729 11.7823 11.137 11.4903 11.278C10.9028 11.5617 10.0433 11.7736 9.05909 11.6477C8.2721 11.547 7.67647 11.1851 7.30301 10.8209C7.11743 10.6399 6.97989 10.4518 6.90224 10.2858C6.86407 10.2043 6.83434 10.1154 6.82847 10.0279C6.82287 9.94451 6.83781 9.81369 6.95049 9.72429C7.01482 9.67325 7.08861 9.62783 7.17427 9.60712C7.26692 9.58472 7.35251 9.59614 7.42835 9.62566C7.49664 9.65224 7.5563 9.69339 7.60355 9.7283C7.62796 9.74632 7.65336 9.76601 7.67797 9.78509L7.67915 9.786C7.70479 9.80588 7.73071 9.82597 7.75877 9.84696C7.96961 10.0047 8.3308 10.2376 9.12302 10.3544C10.2333 10.5181 10.8825 10.3791 11.2816 10.2459C11.3835 10.2119 11.4712 10.1775 11.5509 10.1459C11.556 10.1439 11.5612 10.1419 11.5663 10.1399C11.6376 10.1116 11.7104 10.0828 11.7758 10.0631C11.8451 10.0422 11.9335 10.0225 12.0274 10.036ZM11.6489 10.3592C11.2502 10.5171 10.5362 10.7997 9.08883 10.5863C8.15046 10.4479 7.76508 10.1492 7.5356 9.97128C7.35709 9.83291 7.27292 9.76766 7.09616 9.9079C6.88887 10.0724 7.62719 11.2282 9.08883 11.4152C10.9585 11.6544 12.3447 10.6076 12.1084 10.3343C12.0073 10.2174 11.8819 10.267 11.6489 10.3592Z"
        fill="url(#paint11_linear_4706_230499)"
      />
      <path
        d="M12.8166 8.01064C12.7754 8.52676 12.3834 8.91239 11.941 8.87196C11.4986 8.83153 11.1733 8.38035 11.2145 7.86422C11.2557 7.34809 11.6477 6.96246 12.0901 7.0029C12.5325 7.04333 12.8578 7.49451 12.8166 8.01064Z"
        fill="url(#paint12_radial_4706_230499)"
      />
      <path
        d="M12.8166 8.01064C12.7754 8.52676 12.3834 8.91239 11.941 8.87196C11.4986 8.83153 11.1733 8.38035 11.2145 7.86422C11.2557 7.34809 11.6477 6.96246 12.0901 7.0029C12.5325 7.04333 12.8578 7.49451 12.8166 8.01064Z"
        fill="#421D30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0499 8.03107C13.0013 8.64138 12.5259 9.15986 11.9223 9.1047C11.3187 9.04954 10.9324 8.4523 10.981 7.84199C11.0297 7.23168 11.5051 6.71321 12.1087 6.76837C12.7122 6.82353 13.0986 7.42076 13.0499 8.03107ZM11.9409 8.87106C12.3833 8.9115 12.7754 8.52587 12.8165 8.00974C12.8577 7.49361 12.5324 7.04243 12.09 7.002C11.6476 6.96157 11.2556 7.3472 11.2144 7.86332C11.1733 8.37945 11.4985 8.83063 11.9409 8.87106Z"
        fill="url(#paint13_linear_4706_230499)"
      />
      <path
        d="M8.51388 7.66884C8.47271 8.18497 8.08069 8.57059 7.63829 8.53016C7.19588 8.48973 6.87062 8.03855 6.91178 7.52242C6.95295 7.00629 7.34497 6.62067 7.78737 6.6611C8.22978 6.70153 8.55504 7.15271 8.51388 7.66884Z"
        fill="url(#paint14_radial_4706_230499)"
      />
      <path
        d="M8.51388 7.66884C8.47271 8.18497 8.08069 8.57059 7.63829 8.53016C7.19588 8.48973 6.87062 8.03855 6.91178 7.52242C6.95295 7.00629 7.34497 6.62067 7.78737 6.6611C8.22978 6.70153 8.55504 7.15271 8.51388 7.66884Z"
        fill="#421D30"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.7472 7.68928C8.69852 8.29959 8.22314 8.81806 7.61957 8.7629C7.01601 8.70774 6.62962 8.11051 6.6783 7.5002C6.72699 6.88989 7.20237 6.37141 7.80593 6.42657C8.4095 6.48173 8.79588 7.07897 8.7472 7.68928ZM7.63821 8.52927C8.08061 8.5697 8.47263 8.18407 8.5138 7.66794C8.55497 7.15182 8.2297 6.70064 7.7873 6.6602C7.34489 6.61977 6.95288 7.0054 6.91171 7.52153C6.87054 8.03765 7.1958 8.48884 7.63821 8.52927Z"
        fill="url(#paint15_linear_4706_230499)"
      />
      <path
        d="M3.15424 16.4219C3.69066 17.5417 4.45961 18.0977 6.38651 17.6728C7.04111 17.4516 7.87223 17.1224 8.12425 16.8634C8.29639 16.6563 8.32607 16.34 8.20812 16.1125C8.22165 16.1006 8.23429 16.0885 8.24598 16.0763C8.49736 15.8134 8.49484 15.3307 8.23687 15.0868C8.48774 14.8136 8.4778 14.3286 8.20298 14.0953C9.08484 13.829 9.84625 13.4884 10.3183 13.2475C11.3395 12.7996 10.7864 12.0422 10.0445 12.2125C8.90494 12.3901 7.36476 12.8022 6.2592 13.179C6.08181 13.2257 5.92007 13.2761 5.77353 13.3292C5.75958 13.3203 5.74516 13.3113 5.73026 13.3021C5.46288 13.1365 5.43075 12.7382 5.3946 12.2901C5.36057 11.8682 5.32298 11.4022 5.08212 11.0449C4.49401 10.1725 3.44416 10.6127 3.76664 11.6255C4.02867 12.4482 3.80404 13.067 3.50382 13.5019C3.21989 13.9132 2.5426 15.1895 3.15424 16.4219Z"
        fill="url(#paint16_radial_4706_230499)"
      />
      <path
        d="M3.14945 16.4066C3.68587 17.5264 4.23831 18.0323 6.37454 17.6603C6.82196 17.5824 7.86881 17.13 8.10508 16.8458C8.27722 16.6387 8.3069 16.3224 8.18895 16.0949C8.20248 16.083 8.21511 16.071 8.22681 16.0587C8.47819 15.7958 8.47567 15.3132 8.2177 15.0693C8.46857 14.7961 8.45863 14.311 8.18381 14.0777C9.06567 13.8114 9.82708 13.4708 10.2991 13.2299C11.3204 12.782 10.8566 12.0513 10.0254 12.1949C8.9105 12.3875 7.32622 12.8136 6.24003 13.1614C6.06264 13.2081 5.9009 13.2586 5.75436 13.3116C5.74041 13.3028 5.72599 13.2937 5.71109 13.2845C5.44371 13.1189 5.41157 12.7206 5.37543 12.2725C5.34139 11.8506 5.3038 11.3846 5.06295 11.0274C4.47484 10.1549 3.42499 10.5951 3.74747 11.6079C4.00949 12.4307 3.78487 13.0494 3.48464 13.4843C3.20072 13.8957 2.53781 15.1742 3.14945 16.4066Z"
        fill="url(#paint17_radial_4706_230499)"
      />
      <path
        d="M6.50246 17.6362C4.38927 18.1291 3.68591 17.5267 3.14949 16.4069C2.53785 15.1745 3.20076 13.896 3.48468 13.4846C3.78491 13.0497 5.19218 12.9633 5.71131 13.2848C6.58885 13.8283 5.79847 13.6767 6.35031 13.6124C7.45482 13.4833 7.34961 13.7399 7.51944 14.216C7.78833 14.6461 8.10862 16.0924 7.81535 17.0317C7.626 17.1921 6.8002 17.5329 6.50264 17.6362L6.50246 17.6362Z"
        fill="url(#paint18_radial_4706_230499)"
      />
      <path
        d="M6.38149 13.1174C6.37471 13.1243 6.24542 13.1892 5.98047 13.2424C5.80764 13.2771 5.61362 13.2405 5.53151 13.0845C5.28331 12.613 5.48527 11.6533 5.06324 11.0273C4.47509 10.1548 3.4251 10.5952 3.74775 11.6078C4.00981 12.4306 3.7852 13.0493 3.48498 13.4841C3.38146 13.634 3.22756 13.8992 3.10352 14.2354C4.48096 14.7837 5.78063 13.7263 6.38149 13.1174Z"
        fill="url(#paint19_radial_4706_230499)"
      />
      <path
        d="M6.38149 13.1174C6.37471 13.1243 6.24542 13.1892 5.98047 13.2424C5.80764 13.2771 5.61362 13.2405 5.53151 13.0845C5.28331 12.613 5.48527 11.6533 5.06324 11.0273C4.47509 10.1548 3.4251 10.5952 3.74775 11.6078C4.00981 12.4306 3.7852 13.0493 3.48498 13.4841C3.38146 13.634 3.22756 13.8992 3.10352 14.2354C4.48096 14.7837 5.78063 13.7263 6.38149 13.1174Z"
        fill="url(#paint20_radial_4706_230499)"
      />
      <path
        d="M4.45424 12.2497C4.64593 12.1835 4.70104 11.8399 4.57733 11.4823C4.45362 11.1246 4.19795 10.8883 4.00626 10.9544C3.81457 11.0206 3.75946 11.3642 3.88317 11.7218C4.00688 12.0795 4.26255 12.3158 4.45424 12.2497Z"
        fill="url(#paint21_radial_4706_230499)"
      />
      <path
        d="M6.06502 16.1796C5.59397 16.3604 5.69803 17.2744 6.19245 17.3454C6.85367 17.4404 7.83748 17.2065 8.12448 16.8612C8.41148 16.516 8.30874 15.8717 7.79309 15.8182C7.27725 15.7647 6.53608 15.9988 6.06502 16.1796Z"
        fill="url(#paint22_linear_4706_230499)"
      />
      <path
        d="M6.06502 16.1796C5.59397 16.3604 5.69803 17.2744 6.19245 17.3454C6.85367 17.4404 7.83748 17.2065 8.12448 16.8612C8.41148 16.516 8.30874 15.8717 7.79309 15.8182C7.27725 15.7647 6.53608 15.9988 6.06502 16.1796Z"
        fill="url(#paint23_linear_4706_230499)"
      />
      <path
        d="M8.19755 16.1074C7.93801 16.3129 7.32834 16.5085 6.74805 16.6015C7.07866 16.5831 7.90783 16.7171 8.24946 16.6015C8.27459 16.5096 8.32242 16.2958 8.19755 16.1074Z"
        fill="url(#paint24_radial_4706_230499)"
      />
      <path
        d="M5.87659 15.3463C5.32815 15.5458 5.32542 16.5944 6.00564 16.6203C6.76868 16.6494 7.90556 16.4319 8.24828 16.0734C8.59101 15.715 8.46861 14.954 7.87729 14.9191C7.28596 14.8841 6.42502 15.1468 5.87659 15.3463Z"
        fill="url(#paint25_linear_4706_230499)"
      />
      <path
        d="M5.87659 15.3463C5.32815 15.5458 5.32542 16.5944 6.00564 16.6203C6.76868 16.6494 7.90556 16.4319 8.24828 16.0734C8.59101 15.715 8.46861 14.954 7.87729 14.9191C7.28596 14.8841 6.42502 15.1468 5.87659 15.3463Z"
        fill="url(#paint26_linear_4706_230499)"
      />
      <path
        d="M8.24569 15.085C8.18508 15.2281 7.35296 15.5194 6.82129 15.6434C7.1519 15.6251 8.0962 15.6312 8.43783 15.5156C8.42588 15.3827 8.37156 15.2142 8.24569 15.085Z"
        fill="url(#paint27_radial_4706_230499)"
      />
      <path
        d="M5.58847 14.4287C5.01947 14.6515 4.99802 15.6291 5.7129 15.7014C6.59649 15.7907 7.87137 15.4563 8.22408 15.0959C8.57684 14.7357 8.45596 13.9758 7.85154 13.9441C7.24712 13.9124 6.14472 14.2108 5.58847 14.4287Z"
        fill="url(#paint28_linear_4706_230499)"
      />
      <path
        d="M5.58847 14.4287C5.01947 14.6515 4.99802 15.6291 5.7129 15.7014C6.59649 15.7907 7.87137 15.4563 8.22408 15.0959C8.57684 14.7357 8.45596 13.9758 7.85154 13.9441C7.24712 13.9124 6.14472 14.2108 5.58847 14.4287Z"
        fill="url(#paint29_linear_4706_230499)"
      />
      <path
        d="M6.80047 14.3556C6.47793 14.4733 6.43696 14.9161 6.83171 14.9276C7.31963 14.9418 8.07165 14.8308 8.2782 14.6573C8.51086 14.5429 8.32894 14.1621 8.1539 14.0369C7.81927 14.0405 7.11579 14.2406 6.80047 14.3556Z"
        fill="url(#paint30_radial_4706_230499)"
      />
      <path
        d="M5.93951 13.2561C3.67676 13.8517 4.26361 14.9704 6.16447 14.4851C7.82745 14.3679 9.51651 13.6716 10.3268 13.2561C11.3618 12.7972 10.9394 11.984 10.0249 12.1963C8.67878 12.5086 7.03958 12.8626 5.93951 13.2561Z"
        fill="url(#paint31_radial_4706_230499)"
      />
      <g opacity="0.6">
        <path
          d="M7.9305 12.7879C7.00055 13.0368 6.31343 13.2607 5.95466 13.3979C5.81247 13.4522 5.64964 13.422 5.56016 13.2988C5.35949 13.0226 5.10103 12.6302 4.89004 12.7282C4.46072 12.8878 4.95521 13.9826 5.28206 14.0801C5.60891 14.1775 7.61004 13.3391 8.04892 13.2216C9.26323 12.8966 10.2088 12.5383 10.1708 12.3965C10.1327 12.2547 9.14482 12.4628 7.9305 12.7879Z"
          fill="url(#paint32_radial_4706_230499)"
        />
        <path
          d="M7.9305 12.7879C7.00055 13.0368 6.31343 13.2607 5.95466 13.3979C5.81247 13.4522 5.64964 13.422 5.56016 13.2988C5.35949 13.0226 5.10103 12.6302 4.89004 12.7282C4.46072 12.8878 4.95521 13.9826 5.28206 14.0801C5.60891 14.1775 7.61004 13.3391 8.04892 13.2216C9.26323 12.8966 10.2088 12.5383 10.1708 12.3965C10.1327 12.2547 9.14482 12.4628 7.9305 12.7879Z"
          fill="url(#paint33_radial_4706_230499)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_4706_230499"
          x="4.69483"
          y="1.56885"
          width="10.7031"
          height="7.1953"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.885007"
            result="effect1_foregroundBlur_4706_230499"
          />
        </filter>
        <radialGradient
          id="paint0_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.80843 3.71429) scale(13.1441)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.43" stopColor="#FFD400" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#FF8E00" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.8307 3.97885) rotate(54.7041) scale(13.945 13.929)"
        >
          <stop offset="0.608798" stopColor="#FFE437" stopOpacity="0" />
          <stop offset="0.858784" stopColor="#FF79B1" stopOpacity="0.45" />
          <stop offset="0.994222" stopColor="#FF3673" stopOpacity="0.56" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.0964 7.96194) rotate(137.595) scale(9.08661 9.07617)"
        >
          <stop offset="0.608798" stopColor="#FFE437" stopOpacity="0" />
          <stop offset="0.846583" stopColor="#FF8979" stopOpacity="0.45" />
          <stop offset="0.994222" stopColor="#FF6636" stopOpacity="0.56" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.0176 10.2049) rotate(-90) scale(7.73511 7.38974)"
        >
          <stop offset="0.848958" stopColor="#FFC60C" stopOpacity="0" />
          <stop offset="1" stopColor="#FF7039" stopOpacity="0.68" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.0176 9.56459) rotate(90) scale(7.35142 7.28983)"
        >
          <stop offset="0.847356" stopColor="#FE789B" stopOpacity="0" />
          <stop offset="1" stopColor="#F11414" stopOpacity="0.41" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.0463 5.16661) rotate(89.9999) scale(1.82775 3.36018)"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#647AE0" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.78882 13.7554) rotate(145.413) scale(1.97714 2.37972)"
        >
          <stop stopColor="#CE1E1E" />
          <stop offset="1" stopColor="#FFA401" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.28713 13.4918) rotate(133.647) scale(1.44221 1.43423)"
        >
          <stop stopColor="#CE1E1E" />
          <stop offset="1" stopColor="#FFA401" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.93505 12.6412) rotate(144.942) scale(1.61241 1.47197)"
        >
          <stop stopColor="#CE1E1E" />
          <stop offset="1" stopColor="#FFA401" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.2718 3.42046) rotate(27.4869) scale(3.83579 3.48347)"
        >
          <stop offset="0.82" stopColor="#9C2800" />
          <stop offset="1" stopColor="#C24C1E" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.44607 2.7223) rotate(-180) scale(4.19149 3.64501)"
        >
          <stop offset="0.82" stopColor="#9C2800" />
          <stop offset="1" stopColor="#C24C1E" />
        </radialGradient>
        <linearGradient
          id="paint11_linear_4706_230499"
          x1="9.75553"
          y1="9.92214"
          x2="9.51254"
          y2="11.4296"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.347904" stopColor="#FD9E28" stopOpacity="0.8" />
          <stop offset="1" stopColor="#FFE9AD" />
        </linearGradient>
        <radialGradient
          id="paint12_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.5877 14.3188) rotate(5.22185) scale(1.99783 7.25357)"
        >
          <stop offset="0.82" stopColor="#9C2800" />
          <stop offset="1" stopColor="#C24C1E" />
        </radialGradient>
        <linearGradient
          id="paint13_linear_4706_230499"
          x1="12.1019"
          y1="6.85272"
          x2="11.2384"
          y2="8.40195"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0345786" stopColor="#FD9E28" />
          <stop offset="1" stopColor="#FFE5A6" />
        </linearGradient>
        <radialGradient
          id="paint14_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.28501 13.977) rotate(5.22185) scale(1.99783 7.25357)"
        >
          <stop offset="0.82" stopColor="#9C2800" />
          <stop offset="1" stopColor="#C24C1E" />
        </radialGradient>
        <linearGradient
          id="paint15_linear_4706_230499"
          x1="7.7992"
          y1="6.51093"
          x2="6.93562"
          y2="8.06015"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0345786" stopColor="#FD9E28" />
          <stop offset="1" stopColor="#FFE5A6" />
        </linearGradient>
        <radialGradient
          id="paint16_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.28293 10.9553) rotate(-14.9848) scale(6.84425 6.83797)"
        >
          <stop stopColor="#FFC700" />
          <stop offset="1" stopColor="#FFB100" />
        </radialGradient>
        <radialGradient
          id="paint17_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.26376 10.9377) rotate(-14.9848) scale(6.84425 6.83797)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#FFB100" />
        </radialGradient>
        <radialGradient
          id="paint18_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.92159 13.9347) rotate(-14.9848) scale(4.00118 3.9975)"
        >
          <stop offset="0.64" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="1" stopColor="#FF7A00" stopOpacity="0.8" />
        </radialGradient>
        <radialGradient
          id="paint19_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0.692941 13.4629) rotate(-13.2042) scale(4.88919 3.88428)"
        >
          <stop offset="0.822465" stopColor="#FFD400" stopOpacity="0" />
          <stop offset="0.99" stopColor="#FFE178" stopOpacity="0.87" />
        </radialGradient>
        <radialGradient
          id="paint20_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.77108 13.7293) rotate(127.793) scale(3.98815 3.20308)"
        >
          <stop stopColor="#FFDE3A" />
          <stop offset="1" stopColor="#FFDC2F" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint21_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.23427 11.6754) rotate(70.9212) scale(0.673862 0.263568)"
        >
          <stop stopColor="white" stopOpacity="0.4" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint22_linear_4706_230499"
          x1="7.88964"
          y1="16.5317"
          x2="7.09944"
          y2="16.928"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD816" />
          <stop offset="1" stopColor="#FFD816" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_4706_230499"
          x1="7.40457"
          y1="16.5225"
          x2="8.35094"
          y2="16.3838"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCF01" stopOpacity="0" />
          <stop offset="0.910578" stopColor="#F98702" />
        </linearGradient>
        <radialGradient
          id="paint24_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.80172 16.3038) rotate(171.957) scale(1.06414 0.430491)"
        >
          <stop offset="0.391626" stopColor="#F98702" stopOpacity="0.8" />
          <stop offset="1" stopColor="#FFBE18" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint25_linear_4706_230499"
          x1="7.49306"
          y1="15.8608"
          x2="6.14251"
          y2="16.618"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD400" />
          <stop offset="1" stopColor="#FFD816" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_4706_230499"
          x1="7.39901"
          y1="15.6961"
          x2="8.51449"
          y2="15.5457"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCF01" stopOpacity="0" />
          <stop offset="0.910578" stopColor="#F98702" />
        </linearGradient>
        <radialGradient
          id="paint27_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.02444 15.2603) rotate(175.494) scale(1.32217 0.430426)"
        >
          <stop offset="0.44" stopColor="#F98702" stopOpacity="0.8" />
          <stop offset="1" stopColor="#FFBE18" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint28_linear_4706_230499"
          x1="7.81923"
          y1="14.7138"
          x2="6.27471"
          y2="15.6592"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD816" />
          <stop offset="1" stopColor="#FFD816" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_4706_230499"
          x1="7.28282"
          y1="14.7493"
          x2="8.50809"
          y2="14.5956"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFCF01" stopOpacity="0" />
          <stop offset="0.910578" stopColor="#F98702" />
        </linearGradient>
        <radialGradient
          id="paint30_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.24586 14.0947) rotate(167.689) scale(1.23257 0.750944)"
        >
          <stop offset="0.23149" stopColor="#F98702" stopOpacity="0.8" />
          <stop offset="1" stopColor="#FBA00D" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint31_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.5502 12.4532) rotate(163.501) scale(6.21895 1.42437)"
        >
          <stop offset="0.136186" stopColor="#FFE58A" />
          <stop offset="0.625" stopColor="#FFD400" />
          <stop offset="1" stopColor="#FFDD37" />
        </radialGradient>
        <radialGradient
          id="paint32_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.96466 12.7011) rotate(165.496) scale(2.0467 0.253423)"
        >
          <stop offset="0.00840106" stopColor="white" stopOpacity="0.67" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint33_radial_4706_230499"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.79336 13.678) rotate(161.801) scale(0.930572 0.31817)"
        >
          <stop offset="0.00840106" stopColor="white" stopOpacity="0.67" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
      </defs>
    </SvgIcon>
  );
};
